import React from 'react';
import { Route, IndexRoute } from 'react-router';
import ActionsMenu from './actionsMenu';

export default (
  <Route path="inicio">
    <IndexRoute component={(props) => <ActionsMenu {...props} />} />
  </Route>
);
